import classNames from "classnames";

import {dateStringWithTimezone} from "@/components/datetime/utils.ts";
import {DateFormatName} from "@/lib/types/common.ts";

type ShortDateUserProps = {
  date: Date;
  timezone?: string;
  dateFormat?: DateFormatName;
  className?: classNames.ArgumentArray | string;
};

export const ShortDateUser = ({date, timezone, dateFormat, className}: ShortDateUserProps) => {
  return <div className={classNames(className)}>{dateStringWithTimezone(date, timezone, dateFormat)}</div>;
};
